import React from 'react';

import { IconButton } from '@material-ui/core';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import { get } from 'lodash';

import { colors } from 'theme/palette';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const Header = ({ studentName, activeTask, gotoPrevTask, gotoNextTask }) => (
  <div className={styles.taskSwitch}>
    <IconButton onClick={gotoPrevTask}>
      <ArrowBackIosRoundedIcon />
    </IconButton>
    <Typography variant="H-TEXT-2" color={colors.blue1} align="center">
      {studentName} - {get(activeTask, 'name')}
    </Typography>
    <IconButton onClick={gotoNextTask}>
      <ArrowForwardIosRoundedIcon />
    </IconButton>
  </div>
);

export default Header;
